import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Saas::FeatureGate @feature={{@feature}} @fallbackFeatureEntitlement={{@fallbackShowContent}}>\n  {{#if this.showContent}}\n    {{yield}}\n  {{/if}}\n</Saas::FeatureGate>", {
  moduleName: "@dashboard/shared-ui/components/saas/feature-activation-gate.hbs"
});